import React, { useState } from "react";
import { Box, Typography, Alert, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { creditAPI } from "../services/api";
import { useDispatch } from "react-redux";
import { fetchCreditBalance } from "../store/slices/creditSlice";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const PayPalCheckout = ({ amount, onSuccess, onError, onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;

  const initialOptions = {
    "client-id": clientId,
    currency: "USD",
    components: "buttons",
    intent: "capture",
    // "disable-funding": "card,credit", // Re-enabled card payments temporarily
    debug: process.env.NODE_ENV === "development",
  };

  const handleCreateOrder = async () => {
    try {
      setError(null);
      const response = await creditAPI.createPayPalOrder({ amount });
      if (response.data.success) {
        return response.data.orderId;
      }
      throw new Error(response.data.message || t("errors.paymentInitFailed"));
    } catch (err) {
      setError(err.message || t("errors.paymentInitFailed"));
      throw err;
    } finally {
    }
  };

  const handleApprove = async (orderId) => {
    try {
      setError(null);
      const response = await creditAPI.capturePayPalOrder({ orderId });
      if (response.data.success) {
        dispatch(fetchCreditBalance());
        onSuccess(response.data);
      } else {
        throw new Error(
          response.data.message || t("errors.paymentCaptureFailed")
        );
      }
    } catch (err) {
      setError(err.message || t("errors.paymentCaptureFailed"));
      onError && onError(err);
    } finally {
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <PayPalScriptProvider options={initialOptions}>
        {/* Card button */}
        <Box>
          <Typography variant="h6" gutterBottom>
            {t("topUpCredits.payWithCard")}
          </Typography>
          <PayPalButtons
            fundingSource="card"
            style={{ layout: "vertical" }}
            createOrder={handleCreateOrder}
            onApprove={(data) => handleApprove(data.orderID)}
          />
        </Box>

        {/* PayPal button */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom>
            {t("topUpCredits.payWithPayPal")}
          </Typography>
          <PayPalButtons
            fundingSource="paypal"
            style={{ layout: "vertical" }}
            createOrder={handleCreateOrder}
            onApprove={(data) => handleApprove(data.orderID)}
          />
        </Box>

        <Divider sx={{ my: 2 }} />
      </PayPalScriptProvider>
    </Box>
  );
};

export default PayPalCheckout;
